export default {
  namespaced: true,
  state: {
    passwordRules: [
      {
        key: 'Login.PasswordRules.PASSWORD_MIN_CHARACTERS_RULE',
        isValid: false,
        regex: '(?=^.{12,}$)'
      },
      {
        key: 'Login.PasswordRules.PASSWORD_DIGIT_RULE',
        isValid: false,
        regex: '.*[0-9].*'
      },
      {
        key: 'Login.PasswordRules.PASSWORD_UPPERCASE_RULE',
        isValid: false,
        regex: '.*[A-Z].*'
      },
      {
        key: 'Login.PasswordRules.PASSWORD_LOWERCASE_RULE',
        isValid: false,
        regex: '.*[a-z].*'
      },
      {
        key: 'Login.PasswordRules.PASSWORD_SPECIAL_CHARACHTERS_RULE',
        tooltipKey: 'Login.SignUp.PASSWORD_SPECIAL_CHARACHTERS_DESC',
        isValid: false,
        regex: '.*[ %:;,_`{}|~#@$!"" & ^<>=/\\*\\+\\-\\.\\?\\[\\]].*'
      },
      {
        key: 'Login.PasswordRules.PASSWORD_SUCCESSIVE_IDENTICAL_RULE',
        isValid: false,
        regex: '^(([a-zA-Z0-9 %:;,_`{}|~#@$!"" & ^<>=/\\*\\+\\-\\.\\?\\[\\]])\\2?(?!\\2))+$'
      }
    ]
  }
}
